import React from 'react'
import _ from 'lodash'
import Griddle from 'griddle-react'
import { Link } from 'react-router'
import * as request from 'superagent'
import NoCache from 'superagent-no-cache'
import { getToken } from '../Commons/Authentication'
import NavigationBar from '../Commons/NavigationBar'
import { ToastContainer, ToastMessage } from 'react-toastr'
import SearchImage from '../../img/icons/general-icons/search_icon.png'
import NotDataAvailable from './UserDataNotAvailable'
import LinkUpdateUser from './LinkUpdateUser'
import EditIcon from '../../img/icons/general-icons/icon_edit.png'
import PatientIcon from '../../img/icons/general-icons/add_user_icon.png'

const ToastMessageFactory = React.createFactory(ToastMessage.animation)

export default class SearchUser extends React.Component {
  constructor (props) {
    super(props)
    this.state = ({ userList: [], showTable: true, loader: 'all', classContainer: 'form-page-container hide' })
    this.listUsers()
  }

  listUsers () {
    request
    .get('api/v1/user/')
    .set('Authorization', 'Bearer ' + getToken())
    .use(NoCache)
    .set('Accept', 'application/json')
    .end((err, res) => {
      if (res) {
        this.setState({ userList: res.body, classContainer: 'form-page-container', loader: 'hide', showTable: true })
      } else {
        if (err) {
          this.refs.container.error('Algo inesperado ocurrió, no se encontraron usuarios', '', {
            closeButton: true
          })
        }
      }
    })
  }

  showUserTable () {
    this.setState({ showTable: true })
  }

  findTypeAhead () {
    let val = this.refs.query.value
    let url = `api/v1/user/typehead?str=${val}`
    this.setState({'url': val, classLink: 'form-field-new-patient'})

    request
    .get(url)
    .set('Authorization', 'Bearer ' + getToken())
    .use(NoCache)
    .set('Accept', 'application/json')
    .end((err, res) => {
      if (res) {
        if (!_.isEmpty(res.body)) {
          this.setState({ userList: res.body })
          this.showUserTable()
        } else if (_.isEmpty(res.body)) {
          this.setState({ userList: {} })
          this.showUserTable()
        } else {
          if (err) {
            this.refs.container.error('No se encontro información de los usuarios', '', {
              closeButton: true
            })
          }
        }
      }
    })
  }

  render () {
    document.title = 'Listado de Usuarios - CORE 3.0'
    var information = this.state.userList
    var UsersData = []
    var columnsData = [
      {
        'columnName': 'Id', visible: false
      },
      {
        'columnName': 'Identificación'
      },
      {
        'columnName': 'Nombre'
      },
      {
        'columnName': 'Email'
      },
      {
        'columnName': 'Rol'
      },
      {
        'columnName': '',
        'customComponent': LinkUpdateUser
      }
    ]
    let i = 0
    _.forEach(information, (key, vals) => {
      i++
      UsersData.push({
        'Id': i,
        'Identificación': key.numeroDocumento,
        'Nombre': key.nombres + ' ' + key.apellidos,
        'Email': key.email,
        'Rol': key.rol[0].label,
        '': EditIcon,
        '': key._id
      })
    })
    return (
      <div className='form-page-container'>
        <NavigationBar />
        <div className={this.state.loader}>
          <div className='loader'></div>
        </div>
        <div className={this.state.classContainer}>
          <ToastContainer toastMessageFactory={ToastMessageFactory} ref='container' className='toast-top-right' />
          <div className='form-field-container'>
            <img className='form-field-image' src={SearchImage}/>
            <input id='searchUser' ref='query' className='form-input-search' onChange={(e) => { this.findTypeAhead() }} type='text' placeholder='Buscar usuario....' />
          </div>
          <div className='table-container'>
            <Griddle tableClassName='table' showFilter={false} showSettings={false} customNoDataComponent={NotDataAvailable} columnMetadata={columnsData} results={UsersData} resultsPerPage={10} enableInfiniteScroll={true} bodyHeight={350}/>
          </div>
          <div className='form-field-new-patient'>
            <img className='form-field-image' src={PatientIcon} />
            <Link className='form-link-new-patient' to={'user'}>Ingresar nuevo usuario</Link>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SearchUser/UserSearchComponent.js